String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};
var SKIT_APP_RTVSLO = (function (helper) {

  var isMobile = helper.isMobile();
  var isDev = helper.isDev();

  var Skit = {
    pageNumber: 0,
    lock: false,
    main_section: 1338,//https://api.rtvslo.si/news/getSections?client_id=82013fb3a531d5414f478747c1aca622&selfId=1338&map=id
    featured_articles_section: 1692,
    client_id: '82013fb3a531d5414f478747c1aca622',
    articles_buffer: [],
    api_url: isDev ? 'api.dev.rtvslo.si' : 'api.rtvslo.si',
    //api_url: 'api.rtvslo.si',

    getScrollY: function () {
      if (window.pageYOffset != undefined) {
        return pageYOffset;
      } else {
        var sx, sy, d = document,
          r = d.documentElement,
          b = d.body;
        sx = r.scrollLeft || b.scrollLeft || 0;
        sy = r.scrollTop || b.scrollTop || 0;
        return sy;
      }

    },

    goHome: function () {
      if (window.location.pathname != '/') window.history.pushState({}, '', '/');
      Skit.lock = false;
      Skit.pageNumber = 0;
      Skit.articles_buffer = [];
      window.scrollTo(0, 0);
      Skit.loadList(Skit.pageNumber);
    },
    setRatingOnClick: function (likeOrNot, newsId, btnElement) {
      var url = 'https://' + Skit.api_url + '/news/setRating/' + newsId + '?client_id=' + Skit.client_id + '&language=sl';
      var fd = new FormData();
      fd.append('rating', likeOrNot ? 5 : 0);
      fd.append('newsId', newsId);
      helper.postAjaxData(url, fd, renderRatting, btnElement, likeOrNot);
    },
    showNews: function (id) {

      var position = Skit.getScrollY();
      //console.log("position", position)
      localStorage.setItem('currentListScrollPosition', position);

      Skit.lock = true;
      helper.pauseAllVideos();
      $('#articles').hide();
      $('#article-list').hide();
      resetVerticalSlider();
      $('#article').show();
      //console.log($('#article')[0]);
      
      $('#article-content').show();
      
      var url = 'https://' + Skit.api_url + '/news/getItem/' + id + '?client_id=' + Skit.client_id + '&prepare=full&language=sl&filters=skip-legacy,rating';
      helper.getAjaxData(url, renderArticle);
    },
    showNoSearchResults: function (searchTerm) {

      var position = Skit.getScrollY();
      //console.log("position", position)
      localStorage.setItem('currentListScrollPosition', position);

      Skit.lock = true;
      helper.pauseAllVideos();
      $('#articles').hide();
      $('#article-list').hide();
      resetVerticalSlider();
      $('#article').show();
      $('#no-results-content').show();
      $('#search-error-content').hide();
      $('#no-results-term').text(searchTerm);
    },

    showSearchError: function () {
      var position = Skit.getScrollY();
      localStorage.setItem('currentListScrollPosition', position);

      Skit.lock = true;
      helper.pauseAllVideos();
      $('#articles').hide();
      $('#article-list').hide();
      resetVerticalSlider();
      $('#article').show();
      $('#no-results-content').hide();
      $('#search-error-content').show();
      $('#no-results-term').text(searchTerm);
    },

    showList: function (unlock, scroll_skip) {
      //console.log('showList', unlock, scroll_skip);
      
      $('#article').hide();
      $('#article').html("");
      $('#nexts-articles-container').hide();
      $('#next-article').html("");
      resetVerticalSlider();

      $('#article-content').hide();

      $('#articles').show();
      $('#article-list').show();
      if (unlock === true) {
        Skit.lock = false;
      }
      scroll_skip = scroll_skip || '';

      if(scroll_skip === true) return;

      setTimeout(function () {
        var position = localStorage.getItem('currentListScrollPosition', position);
        //console.log("position!!!!", position)

          if (position) {
            window.scrollTo({
              top: position,
              left: 0,
              //behavior: 'smooth'
            });
          }

        }, 50)
    },
    loadList: function (pageNumber, skip_scroll) {
      Skit.lock = true;
      //console.log("SKIT_APP_RTVSLO -> Skit.lock ", Skit.lock )
      var section = getState();
      this.showList(false, skip_scroll);
      var sec = this.main_section;
      if (!pageNumber) $('#articles').html(""); // Clear if is not infinite scroll
      var nmr = pageNumber ? pageNumber : 0
      if (section) {
        var sections_reverse = {
          'scena': 1339,
          'info': 1340,
          'kviz': 1341,
          'skit-tv': 1342,
          'podkast': 1346,
          'sport': 3,
          'slovar-spolne-vzgoje': 1670,
          'osvezilna-fronta': 1691,
          'gg': 1722,
          'prvic': 1753
        }
        try {
          sec = sections_reverse[section];
        } catch (e) {
          /**
           * If not on the list show first page
           */
        }
      }

      if (sec == this.main_section && mobile_xs) {
        //console.log('Homepage on mobile XS');
        verticalSliderRender();

        window.mainLogo = document.getElementById('main-logo');
        mainLogo.removeEventListener('click', mainLogoClickHandler);
        mainLogo.addEventListener('click', mainLogoClickHandler);

        return;
      }

      // Hide rotator if not first page
      if (sec != this.main_section) {
        $('#featured-rotator').hide();
      }

      this.setFeaturedRotator(sec, pageNumber, (featured_articles) => {
        var getNewsBySectionId = "https://" + Skit.api_url + "/news/getSectionLayout/" + sec + "?client_id=" + Skit.client_id + "&filters=rating,with-extras,with-recordings&prepare=medium&pageSize=21&exclude=" + featured_articles + "&pageNumber=" + nmr;

        helper.getAjaxData(getNewsBySectionId, function (data) {
          //console.log('data', data); 
          firstPageRender(data, template_monocms_items);
        });
      });

    },

    setFeaturedRotator: function (sec, pageNumber, callback) {

      // Return if not first page
      if (sec != this.main_section ) {
        callback();
        return;
      }

      var self = this;
      var featured_articles = '';

      var getFeaturedSection = "https://" + Skit.api_url + "/news/getSectionLayout/" + self.featured_articles_section + "?client_id=" + Skit.client_id + "&filters=rating,with-extras,with-recordings&prepare=medium&pageSize=3&pageNumber=0";

      // Load featured rotator only if first loading & prevent weird SwiperJS behaviour
      if (pageNumber) {
        helper.getAjaxData(getFeaturedSection, function (data) {

          try {
            if (data.response.length < 1) return;
            var setFeaturedItems = new Promise((resolve, reject) => {
              data.response.forEach((entry,index, array) => {
                featured_articles += entry.id + ',';
                if (index === array.length -1) resolve();
              });
            });

            setFeaturedItems.then(() => {
              callback(featured_articles);
            });

          } catch (error) {
            console.log(error);
          }
        });

        return;
      }

      // Featured rotator
      var featuredRotatorContainer = $('#featured-rotator .swiper-wrapper');
      featuredRotatorContainer.html('');

      helper.getAjaxData(getFeaturedSection, function (data) {

        try {

          if (data.response.length < 1) return;

          //console.log(data);
          let cat
          var setFeaturedItems = new Promise((resolve, reject) => {
            data.response.forEach((entry,index, array) => {

              entry.class = '';

              if(entry && entry.keywords && (entry.keywords.indexOf('skit') > -1 || entry.keywords.indexOf('Skit') > -1)) {
                var meta = Skit.returnClassByKeyword(entry.keywords);
                cat = meta.name;
                entry.class = meta.class;
                entry.section.id = meta.section_id;
              }
              else if (entry && entry.extras && entry.extras.custom_section_name) {
                cat = entry.extras.custom_section_name;
                entry.class = Skit.returnClassByID(entry.section.id, false);
              }
              else {
                cat = Skit.returnClassByID(entry.section.id, false, true);
                entry.class = Skit.returnClassByID(entry.section.id, false);
              }
              entry.category = cat;

              var item = Mustache.render(template_rotator_featured, { data: entry });
              featuredRotatorContainer.append(item);
              featured_articles += entry.id + ',';

              if (index === array.length -1) resolve();
            });
          });

          setFeaturedItems.then(() => {
            callback(featured_articles);
          });

          $('#featured-rotator').show();
          helper.featuredRotatorInit('#featured-rotator .swiper-container');

        } catch (error) {
          console.log(error);
        }
      });

    },

    search: function (pageNumber, skip_scroll) {
      var self = this;
      Skit.lock = true;
      //console.log("SKIT_APP_RTVSLO -> Skit.lock ", Skit.lock )
      //var section = getState();
      this.showList(false, skip_scroll);
      var sec = this.main_section;
      var nmr = pageNumber ? pageNumber : 0;

      var params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
      let value = params.q;
      var url = "https://" + Skit.api_url + "/news/getSearch/?section=" + sec + "&client_id=" + Skit.client_id + "&prepare=medium&pageSize=21&pageNumber=" + nmr + "&q=" + value;

     // if(helper.isDev()){
        url = "https://" +Skit.api_url + "/elastic/query?client_id="  + Skit.client_id;
        var fd = new FormData();
        let alias = 'news_1338_alias';
        let index = 'news_index';
        fd.append('q', value);
        fd.append('index', index);
        fd.append('alias', alias);
        fd.append('pageSize', 12);
        fd.append('pageNumber', nmr);
        fd.append('fuzziness', 'low');
        fd.append('fields', 'title:10 keywords:5 lead_short:2 content:1');
        fd.append('recency', 'average');
        fd.append('active', 'active');

        var keywordsAPIUrl = "https://" + Skit.api_url + "/news/getSearchKeywords?client_id="  + Skit.client_id + "&pageNumber=0&pageSize=4&q=" + value;

        helper.postAjaxData2(url, fd, function (data) {
          let response = [];
          if (typeof data.response !== 'undefined' && typeof data.response[index] !== 'undefined'  && typeof data.response[index].hits !== 'undefined') {
            response = data.response[index].hits;
          }


          //modify response convert _id to id ..., _source.title to title ...
          response = response.map(function(item){
            item.id = item._source.id;
            item.title = item._source.title;
            item.lead = item._source.lead_short;
            item.section = {
              id: item._source.section_id
            }
            item.lead_image = {
              image: {
                'fp-md': item._source.image.replace('.jpg', '_fp-md.jpg')
              }
            }
            return item;
          });

          //console.log('data', response);

          let wrapp = {
            'response':response
          }

          var keywordSuggestions = [];

          function renderResults() {
            try{
              if (data.error) self.showSearchError();
              if (data.response[index].hits.length == 0 && nmr == 0) self.showNoSearchResults(value);
            }catch(e){
              console.log(e);
            }
            //console.log('keywordSuggestions',keywordSuggestions);
            firstPageRender(wrapp, template_monocms_items, value, keywordSuggestions);
          }

          // Fetch keywords on first page only to prevent unnecessary requests
          if (nmr == 0) {
            helper.getAjaxData(keywordsAPIUrl, function (data) {
              //console.log(data);
              if(data && data.response && data.response.results && data.response.results.length > 0){
                keywordSuggestions['results'] = data.response.results;
              }
              renderResults();
            });
          }
          else {
            renderResults();
          }
        });
    //  }
      /*
      else {
        helper.getAjaxData(url, function (data) {
          //console.log('data', data);
          if (data.response.length == 0 && nmr == 0) self.showNoSearchResults(value);
          firstPageRender(data, template_monocms_items, value);
        });

      }
      */




    },

    navigate2section: function (section_id) {

      window.location = Skit.returnClassByID(section_id, true);
    },

    returnClassByKeyword: function (keywords) {
      //console.log("🚀 ~ file: index.js ~ line 134 ~ keywords", keywords)

      var item = {};
      item.class = 'bg-color--blue-dark blue-dark';
      item.url = '/';
      item.name = 'Skit';
      item.section_id = 1340;
      if(typeof keywords !== 'string'){
        return item;
      }
      keywords = keywords.toLowerCase()
      if (keywords.indexOf('kviz') > -1) {
        item.class = 'bg-color--red red';
        item.url = '/kviz';
        item.name = 'Kviz';
        item.section_id = 1341;
      }

      if (keywords.indexOf('skit tv') > -1) {
        item.class = 'bg-color--green green';
        item.url = '/skit-tv';
        item.name = 'TV';
        item.section_id = 1342;
      }

     if (keywords.indexOf('info') > -1) {
        item.class = 'bg-color--yellow yellow';
        item.url = '/info';
        item.name = 'Info';
        item.section_id = 1340;
      }

      if (keywords.indexOf('scena') > -1) {
        item.class = 'bg-color--cyan cyan';
        item.url = '/scena';
        item.name = 'Scena';
        item.section_id = 1339;
      }

      if (keywords.indexOf('podkast') > -1) {
        item.class = 'bg-color--red red';
        item.url = '/podkast';
        item.name = 'Podkast';
        item.section_id = 1346;
      }

      if (keywords.indexOf('gg') > -1) {
        item.class = 'bg-color--yellow yellow';
        item.url = '/gg';
        item.name = '🎮 GG';
        item.section_id = 1722;
      }

      if (keywords.indexOf('slovar-spolne-vzgoje') > -1) {
        item.class = 'bg-color--purple purple';
        item.url = '/slovar-spolne-vzgoje';
        item.name = 'Slovar spolne vzgoje';
        item.section_id = 1670;
      }

      if (keywords.indexOf('prvič') > -1) {
        item.class = 'bg-color--orange orange';
        item.url = '/prvic';
        item.name = 'Prvič';
        item.section_id = 1753;
      }

      if (keywords.indexOf('osvezilna-fronta') > -1) {
        item.class = 'bg-color--blue-dark blue-dark';
        item.url = '/osvezilna-fronta';
        item.name = 'Osvežilna fronta';
        item.section_id = 1691;
      }


      return item;

    },

    returnClassByID: function (section_id, get_url, get_name) {

      var item = 'bg-color--blue-dark blue-dark';
      var url = '/';
      var name = 'Skit';

      var kviz = ['1245', '1341'];
      if (kviz.includes(section_id)) {
        item = 'bg-color--red red';
        url = '/kviz';
        name = 'Kviz';
      }
      var tv = ['1223', '1306', '740', '103', '101', '1342'];
      if (tv.includes(section_id)) {
        item = 'bg-color--green green';
        url = '/skit-tv';
        name = 'TV';
      }

      var info = ['580', '1340'];
      if (info.includes(section_id)) {
        item = 'bg-color--yellow yellow';
        url = '/info';
        name = 'Info';
      }

      var scena = ['1339', '142'];
      if (scena.includes(section_id)) {
        item = 'bg-color--cyan  cyan';
        url = '/scena';
        name = 'Scena';
      }

      var podcast = ['1346', '504'];
      if (podcast.includes(section_id)) {
        item = 'bg-color--red red';
        url = '/podkast';
        name = 'Podkast';
      }

      var good_game = ['1722'];
      if (good_game.includes(section_id)) {
        item = 'bg-color--yellow yellow';
        url = '/gg';
        name = '🎮 GG';
      }

      var spolna_vzgoja = ['1670'];
      if (spolna_vzgoja.includes(section_id)) {
        item = 'bg-color--purple purple';
        url = '/slovar-spolne-vzgoje';
        name = 'Slovar spolne vzgoje';
      }

      var spolna_vzgoja = ['1753'];
      if (spolna_vzgoja.includes(section_id)) {
        item = 'bg-color--orange orange';
        url = '/prvic';
        name = 'Prvič';
      }

      var osvezilna_fronta = ['1691'];
      if (osvezilna_fronta.includes(section_id)) {
        item = 'bg-color--blue-dark blue-dark';
        url = '/osvezilna-fronta';
        name = 'Osvežilna fronta';
      }

      if (get_url === true) {
        return url;
      }

      if (get_name === true) {
        return name;
      }

      return item;

    }
  };

  var template = $('#template').html();
  var template_item = $('#template_item').html();
  var template_monocms_items = $('#template_monocms_items').html();
  var template_rotator_featured = $('#template_rotator_featured').html();
  Mustache.parse(template);   // optional, speeds up future uses
  Mustache.parse(template_item);
  Mustache.parse(template_monocms_items);
  Mustache.parse(template_rotator_featured);

  /**
   * On URL change
   */

  (function () {
    let previousUrl = window.location.pathname;
    
    function onUrlChange() {
      const currentUrl = window.location.pathname;
      if (currentUrl !== previousUrl) {
        //console.log('URL changed from', previousUrl, 'to', currentUrl);

        if (previousUrl === currentUrl) return; // Ignore hash change

        if (currentUrl == '/') {
          Skit.goHome()
        } else {
          
          var whitelist = ['/iskanje', '/zabava', '/kviz', '/scena', '/skit-tv', '/podkast', '/info', '/slovar-spolne-vzgoje', '/osvezilna-fronta', '/gg', '/prvic'];

          // Load section
          if( whitelist.includes(location.pathname) ) {
            if ( topHeader?.mobileMenuIsOpen == true ) topHeader.mobileMenu(); // Close menu
            Skit.loadList();
          }

          // Load news if ID at the end
          let newsIDfromURL = +location.pathname.split('/').pop();
          //console.log($('#article').is(":visible"));
          if( Number.isInteger( newsIDfromURL ) && $('#article').is(":visible") == false ) {
            //console.log(previousUrl + ' => ' + currentUrl);
            
            if ( topHeader?.mobileMenuIsOpen == true ) topHeader.mobileMenu(); // Close menu
            Skit.showNews(newsIDfromURL);
          }
          
        }

        previousUrl = currentUrl;
      }
    }
    
    // Hook into history methods
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      onUrlChange(); // Trigger on pushState
    };
    
    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      onUrlChange(); // Trigger on replaceState
    };
    
    // Listen to hashchange event
    window.addEventListener('hashchange', onUrlChange);
    
    // Optional: Poll for changes (if needed for unsupported edge cases)
    setInterval(() => {
      if (window.location.href !== previousUrl) {
        onUrlChange();
      }
    }, 100); // Adjust polling interval as necessary
  })();


  /*window.addEventListener('popstate', function (event) {
    //console.log("event", event)
    //console.log("event", location)

    // Ignore hash change
    if (event.target.location.pathname === Skit.previous_url) {
      event.preventDefault();
      return;
    }

    var whitelist = ['/', '/iskanje', '/zabava', '/kviz', '/scena', '/skit-tv', '/podkast', '/info', '/slovar-spolne-vzgoje', '/osvezilna-fronta', '/gg', '/prvic'];

    if(whitelist.includes(location.pathname) || Number.isInteger( +window.location.pathname.split('/').pop()) ){ // Check if last part is number in case of article
      Skit.showList(true);

      // If homepage render vertical slider
      if (event.target.location.pathname == '/' && mobile_xs) {
        //verticalSliderRender();
      }
    }

    Skit.previous_url = event.target.location.pathname;

  });*/


  //Infinite Scroll
  $(window).on("scroll", function (e) {
    e.preventDefault();
    if (Skit.lock === true) return;//skip when loading items
    //page height
    var scrollHeight = $(document).height();
    //scroll position
    var scrollPos = $(window).height() + $(window).scrollTop();
    // fire if the scroll position is 300 pixels above the bottom of the page
    if (((scrollHeight - 300) >= scrollPos) / scrollHeight == 0) {
      //$('.load-more-days-button').click();
      //console.log('page', Skit.pageNumber);
      Skit.pageNumber++;
      //if (Skit.pageNumber < 10) {
        Skit.lock = true;
        var skip_scroll = true;
        var state = getState();
        if ( state == 'iskanje' ) {
          Skit.search(Skit.pageNumber, skip_scroll);
          //console.log('iskanje');
        } else {
          Skit.loadList(Skit.pageNumber, skip_scroll);
          //console.log('običajno');
        }
        console.log(Skit.pageNumber);
      //}
    }
  });



  function renderRatting(btnElement, data, likeOrNot) {
    //console.log("renderRatting -> data", data)
    //console.log("renderRatting -> element", btnElement)

    // Flush news cache
    helper.flushLocalStorage('news/getSectionLayout');

    let btnElementParent = btnElement.parentElement;
    let addLikeBtn = btnElementParent.querySelector('.like-add');
    let removeLikeBtn = btnElementParent.querySelector('.like-remove');
    let addlikeCounter = addLikeBtn.querySelector('.like-counter');
    let removelikeCounter = removeLikeBtn.querySelector('.like-counter');
    let voteCount = data['response']['vote_count'];

  
    try {
      if (likeOrNot) {
        removelikeCounter.innerHTML = voteCount;
        (voteCount > 0 ) ? removelikeCounter.classList.remove('d-none') : removelikeCounter.classList.add('d-none');

        addLikeBtn.classList.add('d-none');
        removeLikeBtn.classList.remove('d-none');
      } else {
        addlikeCounter.innerHTML = voteCount;
        (voteCount > 0 ) ? addlikeCounter.classList.remove('d-none') : addlikeCounter.classList.add('d-none');

        addLikeBtn.classList.remove('d-none');
        removeLikeBtn.classList.add('d-none');
      }
    } catch (e) {
      console.log(e);
    }

  }


  function renderArticle(data) {

    if (!data || !data.response) {
      return;
    }

    // Set Skit title if exists
    data.response.title = data.response.extras?.skit_title ? data.response.extras.skit_title : data.response.title;

    var first = '';


    /**
     * Open link in exteral browser
     */
    /*
    if (data && data.response && data.response.content) {
      first = data.response.content.replace(/href=\"\//g, 'target=\"_blank\" href=\"http:\/\/www.rtvslo.si\/');
      first = first.replace(/data-instgrm-captioned/g, "");
      //first = first.replace(/data-instgrm-captioned/g, "data-instgrm-captioned hidecaption=\'true\'");

    }
    */
    var galley_images = [];
    if (data && data.response && data.response.fullcontent) {
      var elements = $.parseHTML(data.response.fullcontent);
      var images = $(elements).find('img');
      //console.log('images', images);
      images.map(function (itm) {
        var imgEl = images[itm];
        //console.log('itm', imgEl);
        var temp = {
          src: imgEl.src,
          thumb: imgEl.src.replace('.jpg', '_fp-md.jpg'),
          title: imgEl.title
        }
        galley_images.push(temp);
      })
    }

    data.response.galley_images = galley_images;

    data.response.lead = data.response.lead.replace(/Statična stran/g, '');
    data.response.subtitle = data.response.subtitle.replace(/Statična stran/g, '');

    var stateObj = {
      id: data.response.id
    };

    if (window.location.pathname != data.response.link) {
      //console.log('Pushing state object in renderArticle');
      history.pushState(stateObj, "", data.response.link);
    }


    data.response.content = data.response.content.replaceAll("table-bordered", "table table-bordered");

    var next_items = [];

    if(Skit.articles_buffer.length > 0){
      /*var filter_items = Skit.articles_buffer.filter(function(itm, index){
        return itm.id == data.response.id;
      });
      if(filter_items.length > 0){
        next_item = filter_items[0];
      }*/

      var newArr = Skit.articles_buffer.reduce(function(acc, curr, index) {
        if (curr.id == data.response.id) {
          acc.push(index);
        }
        return acc;
      }, []);

      if(newArr.length > 0){
          var index = newArr[0] + 1;
          //var k = 0;
          Skit.articles_buffer.map(function(itm, i){
            if(i >= index && next_items.length < 3){
              itm.playvideo = false;
              itm.footer_style ='display:none;';
              next_items.push(itm);

            }
          });
      }

      //console.log(next_items);


    }

    function stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }

    data.response.signature = stripHtml(data.response.signature);

    /* SmartOcto data */
    var publishDate = new Date(data.response.stamp);
    data.response.publishDate = publishDate.toISOString();

    var authors = '';
    if (data.response.author_short !== '-1') {      

      switch (Number(data.response.author_short)) {
        case 0:
          authors = data.response.author.title;
          break;
        case 1:
          authors = data.response.author.inic1;
          break;
        case 2:
          authors = data.response.author.inic2;
          break;
        case 3:
          authors = data.response.author.inic3;
          break;
        case 4:
          authors = data.response.author.inic4;
          break;
      }
    }
    if ($(data.response.authors).length > 0) {
      $(data.response.authors).each(function (){
        if (authors.length !== 0) {
          authors += ', ';
        }
        authors += this.author.title;
      });
    }
    if (data.response.author_extra.length > 0) {
      if (authors.length !== 0) {
        authors += ', ';
      }
      authors += data.response.author_extra;
    }
    data.response.authors = authors;

    var keywordList = '';
    keywordList += '<a class="news-keywords__keyword--section" href="javascript:void(0)" onclick="event.stopPropagation();window.history.pushState({}, \'\', \'/' + data.response.section.url + '\');">#' + data.response.section.title + '</a>';
    if (data.response.keywordsList) {
      data.response.keywordsList.forEach( keyword => {
        keywordList += '<a class="news-keywords__keyword--tags" onclick="event.stopPropagation();" href="/iskanje?q=' + keyword.title + '">#' + keyword.title + '</a>';
      });
    }

    data.response.keywords = keywordList;

    //console.log("🚀 ~ file: index.js ~ line 320 ~ renderArticle ~ data.response", data.response)

    /*var createSectionPromise = new Promise((resolve, reject) => {
      helper.createSectionTree(data.response.section.id);
      setTimeout(function(){
       resolve();
      },300);
    });
    createSectionPromise.then(function () {
      var sectionTreeList = helper.readSectionsList();
      var sections = '';
      if (typeof sectionTreeList !== 'undefined') {
        var i = 0;
        $(sectionTreeList).each(function() {
          i++;
          sections += this.title;
          if (i < sectionTreeList.length) {
            sections += '>';
          }
        });
        data.response.sections = sections;
      }
    });*/
    data.response.sections = 'Skit>' + data.response.section.title;

    var tags = '';
    if (data.response.keywordsList.length > 0) {
      var t = 0;
      $(data.response.keywordsList).each(function () {
        t++;
        tags += this.title;
        if (t < data.response.keywordsList.length){
            tags +=', ';
        }
      });
    }
    data.response.tags = tags;

    //data.response.title = data.response.title.replace('"','&quot;');

    //console.log(data.response);

    function translateAvaSource(avaSource) {
      if (avaSource.length > 0) {
        const avaSourceItems = avaSource.split(',');
        const avaSourceLibrary = {
          'RA1': 'Prvi',
          'VAL202': 'Val202',
          'ARS': 'Ars',
          'RACAP': 'Radio Capodistria',
          'RAKP': 'Radio Koper',
          'RAMB': 'Radio Maribor',
          'RASI': 'Radio Si',
          'RAMMR': 'MMR',
          'RAZ': 'Radio Z',
          'UKR': 'Ukraina',
          'RASPORT202': 'Val202 Šport',
          'SLO1': 'TV Slovenija 1',
          'SLO2': 'TV Slovenija 2',
          'SLO3': 'TV Slovenija 3',
          'TVMMC': 'MMC TV',
          'TVKP': 'TV Koper Capodistria',
          'TVMB': 'TV Maribor'
        };
    
        return avaSourceItems
          .map(avaSourceItem => {
            avaSourceItem = avaSourceItem.trim();
            if (avaSourceItem in avaSourceLibrary) {
              return avaSourceLibrary[avaSourceItem];
            } else {
              return avaSourceItem;
            }
          })
          .join(', ');
      }
      
      return avaSource;
    }    

    data.response.source = translateAvaSource(data.response.source);

    // Init comments drawer
    var commentWidget = () => {
      if (typeof RTVCommentWidget != 'function') return;
      if (!window.commentWidget) window.commentWidget = new RTVCommentWidget();
    }

    var rendered = Mustache.render(template, { data: data.response, isMobile: isMobile, links: [], commentWidget: commentWidget});

    var item = Skit.returnClassByID(data.response.section.id);
    $('#article').parent().addClass(item);
    $('#article').html(rendered);

    var fb = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://skit.rtvslo.si' + data.response.link);
    $('.facebook-href').attr('href', fb);

    var tw = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(data.response.title) + '&url=' + encodeURIComponent('https://skit.rtvslo.si' + data.response.link);
    $('.twitter-href').attr('href', tw);

    var email = "javascript:location.href='mailto:?subject=" + encodeURIComponent(data.response.title) + "&body=" + data.response.lead + " " + encodeURIComponent('https://skit.rtvslo.si' + data.response.link) + "'";
    $('.email-href').attr('href', email);


    window.scrollTo(0, 0);

    setTimeout(function () {
      if (window.onPageLoad) {
        window.onPageLoad();
      }

      helper.socialInit();
      helper.videoInArticle();
      helper.tableInArticle();
      helper.riddleInitDOM();
      helper.infogramInitDOM();
      helper.swapGalleryPositionDOM();

      if(next_items && next_items.length > 0) {
        var rendered_next = Mustache.render(template_monocms_items, { data: next_items });
        //console.log("🚀 ~ file: index.js ~ line 356 ~ rendered_next", rendered_next)
        $('#nexts-articles-container').show();
        $('#next-article').html(rendered_next);
      }else{
        $('#nexts-articles-container').hide();
      }

    }, 50)



    window._nativeShareGlobal = {
      title: data.response.title,
      description: data.response.lead,
      url: "https://skit.rtvslo.si" + data.response.link
    }


  }

  var prettifyTime = (seconds) => new Date(1000 * seconds).toISOString().substring(11, 19).replace(/^0(?:0:0?)?/, '');


  function firstPageRender(data, template, searchTerm, keywordSuggestions) {

    if (data && data.response && data.response.length === 0) {
      //console.log('empty');
      return;
    }

    var articles = [];//data.response;

    data.response.map(function (item) {
      var event_date = '';
      var cat = '';
      //console.log("🚀 ~ file: index.js ~ line 447 ~ cat", cat, item.title)
      item.class = '';

      item.title = item.extras?.skit_title ? item.extras.skit_title : item.title;

      if(item && item.keywords && (item.keywords.indexOf('skit') > -1 || item.keywords.indexOf('Skit') > -1)) {
        var meta = Skit.returnClassByKeyword(item.keywords);
        cat = meta.name;
        item.class = meta.class;
        item.section.id = meta.section_id;
      }
      else if (item && item.extras && item.extras.custom_section_name) {
        cat = item.extras.custom_section_name;
        item.class = Skit.returnClassByID(item.section.id, false);
      }
      else {
        cat = Skit.returnClassByID(item.section.id, false, true);
        item.class = Skit.returnClassByID(item.section.id, false);
      }
      item.event_date = event_date;
      item.category = cat;
      item.type = 'novica';
      item.newsId = item.id;
      item.title = item.title.replace(/'/g, '');
      item.lead = item.lead.replace(/'/g, '');
      //itemitem.link = item.link.replace('/skit', '');
      item.url = item.link;
      //console.log("🚀 ~ file: index.js ~ line 471 ~ item.link", item.link)
      item.link = encodeURIComponent('https://skit.rtvslo.si' + item.link);
      item.podcast = false;
      item.podcast_name = "";
      item.podcast_link = "";
      if (item.recordings && item.recordings[0] &&  item.recordings[0].podcast) {
        if (item.recordings[0].podcast == 1) {
          item.podcast = true;
          item.podcast_name = item.recordings[0].showName;
          item.podcast_link = encodeURI(item.recordings[0].showName) + '/' + item.recordings[0].showId;
          item.recording_duration = prettifyTime(item.recordings[0].duration);
        }
      }

      if (item && item.extras && item.extras.live_channel_in_list == '1' && item.extras.live_channel) {
        item.channel = item.extras.live_channel;
        item.channel_id = item.channel.replace('.', '_');
        item.type = 'video';
        item.playvideo = true;
        item.playLivevideo = true;
      }
      else if (item.recordings && item.recordings.length && item.recordings.length > 0) {
        item.rec_id = item.recordings[0].id;
        item.type = 'video';
        item.playvideo = true;
        item.recording_duration = prettifyTime(item.recordings[0].duration);
      }
      else if(item && item.extras && item.extras.yt_id) {
          item.yt_id =item.extras.yt_id;
          item.type = 'video';
          item.playvideo = true;
          item.playYTvideo = true;
      }

      item.publish_date = item.date;
      articles.push(item);

      Skit.articles_buffer.push(item);


    });


    var render_items = Mustache.render(template, { data: articles, isMobile: isMobile });

    $('#articles').append($(render_items));

    // Show search alert if searching
    if (searchTerm) {
      $('#article-list-search-alert .search-term').text(searchTerm);
      $('#article-list-search-alert').show();
    } else {
      $('#article-list-search-alert').hide();
    }

    // Show suggestions if exists
    if (keywordSuggestions && keywordSuggestions.results) {
      var keysNumber = Object.keys(keywordSuggestions.results).length - 1;
      var i = 0;

      for (const [key, result] of Object.entries(keywordSuggestions.results)) {
        if (result.title != searchTerm) $('#search-keyword-suggestions .search-suggestions').append( '<a href="/iskanje?q=' + result.title + '" style="color: #005f60;">' + result.title + '</a>' + (keysNumber == i ? '.' : ', ') );
        i++;
      }
      if ( ! $('#search-keyword-suggestions .search-suggestions').is(':empty') ) $('#search-keyword-suggestions').show();
    } else {
      if ( $('#search-keyword-suggestions .search-suggestions').is(':empty') ) $('#search-keyword-suggestions').hide();
    }


    if (blurLazyLoad) {
      //console.log("firstPageRender -> blurLazyLoad", blurLazyLoad)
      blurLazyLoad.init();
    }

    helper.initVideo()

    Skit.lock = false;
  }

  function getState() {
    var n = window.location.href.lastIndexOf('/');
    var id =  window.location.href.substring(n + 1);
    id = id.split('#')[0]; // Remove hash URL first to prevent weird behavior
    
    id = id.split('?');
    if(id.length > 0){
      return id[0]
    }
    return id;
  }



  /**
   * BASIC ROUTER!!!!
   */

  window.scrollTo(0, 0);

  var id = getState();
  
  if (Number(id)) {
    Skit.showNews(id)
  } else if (id == 'iskanje') {
    Skit.search();
  } else {
    Skit.loadList();
  }




  return Skit;

})(SKIT_APP_HELPER);
